import { Reveal } from '@/components/ui/Reveal'

import { SectionLabel } from './HowItWorks'

const testimonials = [
  {
    initials: 'AK',
    name: 'Arjun Kapoor',
    role: 'Football player · Mumbai',
    stars: 5,
    text: '"Used to spend 20 minutes calling different turfs every week. Now I book in 2 minutes on TurfChale. Can\'t go back to the old way."',
  },
  {
    initials: 'SR',
    name: 'Sneha Reddy',
    role: 'Badminton player · Hyderabad',
    stars: 5,
    text: "\"The live slot availability is a game changer. No more 'let me check and get back to you.' You see what's open and book it instantly.\"",
  },
  {
    initials: 'VN',
    name: 'Vikram Nair',
    role: 'Cricket team captain · Bengaluru',
    stars: 5,
    text: '"Our weekend cricket league runs entirely on TurfChale now. Recurring bookings mean our slot is always reserved without lifting a finger."',
  },
]

export function Testimonials() {
  return (
    <section
      className="py-20"
      style={{
        background: 'var(--bg2)',
        borderBottom: '1px solid var(--lime-line)',
        borderTop: '1px solid var(--lime-line)',
      }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <SectionLabel>What players say</SectionLabel>
        <Reveal delay={0.05}>
          <h2
            className="font-display font-bold leading-[1.1] tracking-tight mb-12"
            style={{
              color: 'var(--text)',
              fontSize: 'clamp(1.9rem,3.5vw,2.8rem)',
              letterSpacing: '-.5px',
              maxWidth: 520,
            }}
          >
            Trusted by 50,000+ players
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {testimonials.map((t, i) => (
            <Reveal delay={i * 0.09} key={t.name}>
              <div
                className="rounded-2xl p-6 h-full"
                style={{ background: 'var(--bg3)', border: '1px solid var(--lime-line)' }}
              >
                <div className="text-[0.75rem] mb-3" style={{ color: 'var(--lime)' }}>
                  {'★'.repeat(t.stars)}
                </div>
                <p
                  className="text-[0.85rem] font-light leading-[1.7] italic mb-5"
                  style={{ color: 'var(--muted)' }}
                >
                  {t.text}
                </p>
                <div className="flex items-center gap-3">
                  <div
                    className="w-9 h-9 rounded-full flex items-center justify-center text-[0.8rem] font-bold shrink-0"
                    style={{ background: 'var(--lime-dim)', color: 'var(--lime)' }}
                  >
                    {t.initials}
                  </div>
                  <div>
                    <div className="text-[0.82rem] font-semibold" style={{ color: 'var(--text)' }}>
                      {t.name}
                    </div>
                    <div className="text-[0.72rem]" style={{ color: 'var(--text-dim)' }}>
                      {t.role}
                    </div>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  )
}
